import React from 'react';
import Loader from "react-loader-spinner";
import { Translate as t } from '../../config/Translate';

// 로딩 표시 단일 컴포넌트 (U-45).
// - size: 스피너 크기(px). 기본 50 (기존 호출처 렌더 유지)
// - inline: true 면 블록 중앙정렬 대신 줄 안에 인라인 배치
// - text 가 없으면 스크린리더용 숨김 문구(common.status.loading)를 넣는다
const getDefaultText = () => {
	try {
		return typeof t === 'function' ? (t('common.status.loading') ?? '') : '';
	} catch (e) {
		return '';
	}
};

export const Loading = ({ type = "ThreeDots", text = "", size = 50, inline = false }) => {
	const wrapperClass = inline ? "d-inline-flex align-items-center" : "text-center";
	return (
		<div className={wrapperClass} role="status" aria-live="polite">
			<Loader type={type} color="#00beff" height={size} width={size} timeout={0} />
			{text ? text : <span className="visually-hidden">{getDefaultText()}</span>}
		</div>
	)
}
